<script setup>
import { computed } from 'vue';
import { useMainStore } from '@/store/index.js';
import HeaderLinksSectionJP from './HeaderLinksSectionJP';

const store = useMainStore();
const selectedMarket = computed(() => {
  return String(store.market).toUpperCase();
});
</script>

<template>
  <div class="header-links-container">
    <HeaderLinksSectionJP v-if="selectedMarket === 'JP'" />
  </div>
</template>

<style scoped>
  .header-links-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.5em;

    font-size: 1.2em;
    color: var(--sdds-white);
  }
  
  @media only screen and (max-width: 800px) {
    .header-links-container {
      gap: 1.5em;
      font-size: 1.0em;
    }
  }
  @media only screen and (max-width: 700px) {
    .header-links-container {
      gap: 1.0em;
      font-size: 0.8em;
    }
  }
  @media only screen and (max-width: 575px) {
    .header-links-container {
      gap: 0.5em;
      font-size: 0.7em;
    }
  }
</style>
